<script setup>
import router from "@/router";
import {computed, defineEmits, onMounted, ref, watch} from "vue";
import store from "@/store";
import {siteConfig} from "@/utils/config";

const account = computed(() => store.state.account)
const emit = defineEmits(['query'])
const searchMobile = ref("")
const couponType = computed(() => store.state.coupon)
const type = computed(() => {
  return siteConfig[couponType.value] || {}
})
onMounted(() => {
  store.dispatch("getAccounts")
  store.commit("getCoupon")
  if (Object.keys(account.value).length) {
    searchMobile.value = account.value.phoneNumber
  }
})
watch(account, (to) => {
  searchMobile.value = to.phoneNumber
})
const logout = () => {
  store.commit("removeAccount")
}
</script>

<template>
  <div class="user-items" :class="`${couponType}-info`">
    <div :class="`${couponType}-text`" class="order-info" @click="router.push({name: 'order'})">
      <i class="ticket-font ticket-dingdan6"></i>
      兑换记录
    </div>
  </div>
  <div v-if="Object.keys(account).length" class="user-items" :class="`${couponType}-info`">
    <div :class="`${couponType}-text`" class="order-info" @click="logout">
      <i class="ticket-font ticket-logout"></i>
      退出登录
    </div>
  </div>
  <div class="search" :class="`${couponType}-info`">
    <el-input v-model="searchMobile" :disabled="Object.keys(account).length" :placeholder="`请输入${type.login === 'xm_air'?'白鹭':'川航金熊猫'}会员手机号`" size="large">
      <template #prefix>
        <el-icon :color="`var(${type.login === 'xm_air'?'--el-color-primary':'--el-color-error'})`" size="20">
          <Search/>
        </el-icon>
      </template>
      <template #suffix>
        <el-button v-if="Object.keys(account).length < 1" link :type="type.login === 'xm_air'?'primary':'danger'"
                   @click="emit('query',{mobile:searchMobile})">查询可用{{ type.login === 'xm_air'?'积分':'里程' }}
        </el-button>
        <div v-else style="font-size: .75rem">
          <b>可用里程：<span :style="{color: `var(${type.login === 'xm_air'?'--el-color-primary':'--el-color-error'})`}">{{ account.balance_miles }}{{ type.login === 'xm_air'?'积分':'里程' }}</span></b>
        </div>
      </template>
    </el-input>
  </div>
</template>

<style lang="less" scoped>
.luckin-info {
  position: relative;
  bottom: 49px;
  right: 0;
}
.user-items {
  height: 30px;
  display: flex;
  justify-content: end;
  align-items: center;
  margin-bottom: 10px;

  .order-info {
    background: #ffffff;
    line-height: 30px;
    padding: 0 20px;
    border-radius: 45px 0 0 45px;
    //font-size: .85rem;
    display: flex;
    align-items: center;
    color: var(--theme-btn-text-color);
  }
}

.search {
  box-sizing: border-box;
  background-color: #ffffff;
  //border-radius: 5px;
  margin: auto 15px;
  border-radius: 45px;

  /deep/ .el-input {
    .el-input__wrapper {
      height: 45px;
      box-shadow: none;
      border-radius: 45px;
    }
  }

}
</style>
